export default {

    //empty-states
    no_coupons: 'Upss! No hi ha cupons',
    text_coupon: 'Comença creant un nou cupó de descompte.',
    new_coupon: 'Nou cupó',

}